import React from "react";
import { TTableHeader } from "types/Components/Common/Table/Table"
import { Link } from "react-router";
import CopyableId from "Components/Common/CopyableId/CopyableId";

export const tableNameCallbackClassNames = (item: any) => {
    return (item.product_type as string)?.toLowerCase() === "individual" ? "!text-[#0747A6]" : undefined
}

export const DELTA_KEY = "delta_type"
export const PRODUCT_NAME_KEY = "name"
export const PRODUCT_TYPE_PARENT = "Parent"
export const PRODUCT_TYPE_PRODUCT = "Individual"
export const PRODUCT_TYPE_CHILD = "Child"

export const PLACEHOLDER_IMAGE = "https://cdn1.vectorstock.com/i/thumb-large/50/20/no-photo-or-blank-image-icon-loading-images-vector-37375020.jpg";

export const PRODUCT_TABLE_OPTIONS = {
    disableSort: true,
    height: "490px",
    selectable: true,
    striped: true,
    footer: true,
    image: (item: any) => item.image
}
// product type component in delta table
// Blue is the chip colour (user-pinned 2026-09-07): tone-info tint+ink, the DS blue-chip
// pair. The exact-match "Individual" branch was #E4D7FF/#3007A6 — which IS tone-accent's
// light pair, so that swap is byte-identical in light.
export const ProductTypeComponentTable = ({ item }: any) => {
    return (
        <div className={`tw-p-1 tw-rounded tw-px-2 tw-text-xs ${item.product_type === PRODUCT_TYPE_PRODUCT ? "tw-bg-tone-accent-tint tw-text-tone-accent-ink" : "tw-bg-tone-info-tint tw-text-tone-info-ink"} `}>
            {item.product_type ?? PRODUCT_TYPE_PRODUCT}
        </div>
    )
}

export const ProductNameComponentTable = ({ item }: any) => {
    return (
        <div className={`${(item.product_type === PRODUCT_TYPE_PRODUCT || item.product_type === PRODUCT_TYPE_CHILD) ? "tw-text-accent" : ""} tw-truncate tw-max-w-full tw-block tw-overflow-hidden`}>
            <Link to={item.product_type !== PRODUCT_TYPE_PARENT ? `/gms/product/details/${item.id}` : "#"}>
                {item.name}
            </Link>
        </div>
    )
}

/**
 * The ID cell — the Guide table's interaction (US 13549): the first ten characters,
 * the full ID on hover, and a copy button that confirms with "Copied". Replaces the
 * grey "ID" chip whose hover-portal tooltip had to be chased with the cursor and closed
 * the moment it left. Element ids are keyed on the product ID (unique per row, and
 * stable across pages and sorting): `product-id-<id>`, `product-id-copy-<id>`.
 */
export const ProductIdComponentTable = ({ item }: any) => (
    <CopyableId id={item?.id} idPrefix="product-id" suffix={item?.id ?? ""} />
)

const ID_COLUMN_OPTIONS = {
    width: "150px",
    info: "Hover over an ID to see it in full; click the copy icon to copy it",
    callbackComponent: (item: any) => <ProductIdComponentTable item={item} />,
}

export const tableHeader: TTableHeader[] = [
    {
        name: "Products",
        sortable: true,
        column: "name",
        options: {
            callbackClassNames: tableNameCallbackClassNames,
            width: "400px",
            sticky: [true, { left: "48px" }],
        }
    },
    { name: "Model Number", sortable: true, column: "model_number" },
    { name: "Id", sortable: true, column: DELTA_KEY, options: ID_COLUMN_OPTIONS },
    {
        name: "Type", sortable: true, column: "product_type", options: {
            callbackComponent: (item: any) => <ProductTypeComponentTable item={item} />,
        }
    },
    { name: "Created", sortable: true, column: "created_at" },
    { name: "Product Lifecycle Status", sortable: false, column: "product_lifecycle_status" },
]

export const accordianTableHeader: TTableHeader[] = [
    {
        name: "variant  Name",
        column: "name",
        options: {
            width: "396px",
            sticky: [true, { left: "48px" }],
            callbackClassNames: tableNameCallbackClassNames,
            callbackComponent: (item: any) => <ProductNameComponentTable item={item} />
        }
    },
    { name: "ID", column: DELTA_KEY, options: ID_COLUMN_OPTIONS },
    { name: "Type", column: "product_type", options: { callbackComponent: (item: any) => <ProductTypeComponentTable item={item} /> } },
]

export const SORT = {
    SEPARATE_ASC: "s_asc",
    SEPARATE_DESC: "s_desc",
    ASC: "asc",
    DESC: "desc"
}